export const c991 = [
  {
    serialId: 'L1',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: [],
  },
  {
    serialId: 'E1',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L1'],
  },
  {
    serialId: 'L2',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L1'],
  },
  {
    serialId: 'E2',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L2'],
  },
  {
    serialId: 'L3',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L2'],
  },
  {
    serialId: 'E3',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L3'],
  },
  {
    serialId: 'L4',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L3'],
  },
  {
    serialId: 'E4',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L4'],
  },
  {
    serialId: 'L991005',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L4'],
    displayId: 'L5',
  },
  {
    serialId: 'E991005',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L991005'],
    displayId: 'E5',
  },
  {
    serialId: 'L991006',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L991005'],
    displayId: 'L6',
  },
  {
    serialId: 'E991006',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L991006'],
    displayId: 'E6',
  },
  {
    serialId: 'L991007',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L991006'],
    displayId: 'L7',
  },
  {
    serialId: 'E991007',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L991007'],
    displayId: 'E7',
  },
  {
    serialId: 'L991008',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L991007'],
    displayId: 'L8',
  },
  {
    serialId: 'E991008',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L991008'],
    displayId: 'E8',
  },
];
export const c992 = [
  {
    serialId: 'L1',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: [],
  },
  {
    serialId: 'E1',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L1'],
  },
  {
    serialId: 'L2',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L1'],
  },
  {
    serialId: 'E2',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L2'],
  },
  {
    serialId: 'L3',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L2'],
  },
  {
    serialId: 'E3',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L3'],
  },
  {
    serialId: 'L4',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L3'],
  },
  {
    serialId: 'E4',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L4'],
  },
  {
    serialId: 'L992005',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L4'],
    displayId: 'L5',
  },
  {
    serialId: 'E992005',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L992005'],
    displayId: 'E5',
  },
  {
    serialId: 'L992006',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L992005'],
    displayId: 'L6',
  },
  {
    serialId: 'E992006',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L992006'],
    displayId: 'E6',
  },
  {
    serialId: 'L992007',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L992006'],
    displayId: 'L7',
  },
  {
    serialId: 'E992007',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L992007'],
    displayId: 'E7',
  },
  {
    serialId: 'L992008',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L992007'],
    displayId: 'L8',
  },
  {
    serialId: 'E992008',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L992008'],
    displayId: 'E8',
  },
];
export const c993 = [
  {
    serialId: 'L1',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: [],
  },
  {
    serialId: 'E1',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L1'],
  },
  {
    serialId: 'L2',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L1'],
  },
  {
    serialId: 'E2',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L2'],
  },
  {
    serialId: 'L3',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L2'],
  },
  {
    serialId: 'E3',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L3'],
  },
  {
    serialId: 'L4',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L3'],
  },
  {
    serialId: 'E4',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L4'],
  },
  {
    serialId: 'L993005',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L4'],
    displayId: 'L5',
  },
  {
    serialId: 'E993005',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L993005'],
    displayId: 'E5',
  },
  {
    serialId: 'L993006',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L993005'],
    displayId: 'L6',
  },
  {
    serialId: 'E993006',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L993006'],
    displayId: 'E6',
  },
  {
    serialId: 'L993007',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L993006'],
    displayId: 'L7',
  },
  {
    serialId: 'E993007',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L993007'],
    displayId: 'E7',
  },
  {
    serialId: 'L993008',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L993007'],
    displayId: 'L8',
  },
  {
    serialId: 'E993008',
    unlockAt: '2019-08-10T16:00:00.000Z',
    prerequisites: ['L993008'],
    displayId: 'E8',
  },
];

export const c3 = [
  { serialId: 'L1', unlockAt: '2019-08-11T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E1', unlockAt: '2019-08-12T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'L2', unlockAt: '2019-08-13T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'E2', unlockAt: '2019-08-14T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'L3', unlockAt: '2019-08-18T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'E3', unlockAt: '2019-08-19T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'L4', unlockAt: '2019-08-20T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'E4', unlockAt: '2019-08-21T16:00:00.000Z', prerequisites: ['L4'] },
  { serialId: 'L5', unlockAt: '2019-08-25T16:00:00.000Z', prerequisites: ['L4'] },
  { serialId: 'E5', unlockAt: '2019-08-26T16:00:00.000Z', prerequisites: ['L5'] },
  { serialId: 'R1', unlockAt: '2019-08-27T16:00:00.000Z', prerequisites: ['L5'] },
  { serialId: 'L6', unlockAt: '2019-08-28T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E6', unlockAt: '2019-08-29T16:00:00.000Z', prerequisites: ['L6'] },
  { serialId: 'L7', unlockAt: '2019-09-01T16:00:00.000Z', prerequisites: ['L6'] },
  { serialId: 'E7', unlockAt: '2019-09-02T16:00:00.000Z', prerequisites: ['L7'] },
  { serialId: 'L8', unlockAt: '2019-09-03T16:00:00.000Z', prerequisites: ['L7'] },
  { serialId: 'E8', unlockAt: '2019-09-04T16:00:00.000Z', prerequisites: ['L8'] },
  { serialId: 'L9', unlockAt: '2019-09-08T16:00:00.000Z', prerequisites: ['L8'] },
  { serialId: 'E9', unlockAt: '2019-09-09T16:00:00.000Z', prerequisites: ['L9'] },
  { serialId: 'L10', unlockAt: '2019-09-10T16:00:00.000Z', prerequisites: ['L9'] },
  { serialId: 'E10', unlockAt: '2019-09-11T16:00:00.000Z', prerequisites: ['L10'] },
  { serialId: 'L11', unlockAt: '2019-09-15T16:00:00.000Z', prerequisites: ['L10'] },
  { serialId: 'E11', unlockAt: '2019-09-16T16:00:00.000Z', prerequisites: ['L11'] },
  { serialId: 'L12', unlockAt: '2019-09-17T16:00:00.000Z', prerequisites: ['L11'] },
  { serialId: 'E12', unlockAt: '2019-09-18T16:00:00.000Z', prerequisites: ['L12'] },
  { serialId: 'L13', unlockAt: '2019-09-22T16:00:00.000Z', prerequisites: ['L12'] },
  { serialId: 'E13', unlockAt: '2019-09-23T16:00:00.000Z', prerequisites: ['L13'] },
  { serialId: 'L14', unlockAt: '2019-09-24T16:00:00.000Z', prerequisites: ['L13'] },
  { serialId: 'E14', unlockAt: '2019-09-25T16:00:00.000Z', prerequisites: ['L14'] },
  { serialId: 'L15', unlockAt: '2019-10-08T16:00:00.000Z', prerequisites: ['L14'] },
  { serialId: 'E15', unlockAt: '2019-10-09T16:00:00.000Z', prerequisites: ['L15'] },
  { serialId: 'R2', unlockAt: '2019-10-10T16:00:00.000Z', prerequisites: ['L15'] },
  { serialId: 'L16', unlockAt: '2019-10-13T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E16', unlockAt: '2019-10-14T16:00:00.000Z', prerequisites: ['L16'] },
  { serialId: 'L17', unlockAt: '2019-10-15T16:00:00.000Z', prerequisites: ['L16'] },
  { serialId: 'E17', unlockAt: '2019-10-16T16:00:00.000Z', prerequisites: ['L17'] },
  { serialId: 'L18', unlockAt: '2019-10-20T16:00:00.000Z', prerequisites: ['L17'] },
  { serialId: 'E18', unlockAt: '2019-10-21T16:00:00.000Z', prerequisites: ['L18'] },
  { serialId: 'L19', unlockAt: '2019-10-22T16:00:00.000Z', prerequisites: ['L18'] },
  { serialId: 'E19', unlockAt: '2019-10-23T16:00:00.000Z', prerequisites: ['L19'] },
  { serialId: 'L20', unlockAt: '2019-10-27T16:00:00.000Z', prerequisites: ['L19'] },
  { serialId: 'E20', unlockAt: '2019-10-28T16:00:00.000Z', prerequisites: ['L20'] },
  { serialId: 'L21', unlockAt: '2019-10-29T16:00:00.000Z', prerequisites: ['L20'] },
  { serialId: 'E21', unlockAt: '2019-10-30T16:00:00.000Z', prerequisites: ['L21'] },
  { serialId: 'L22', unlockAt: '2019-11-03T16:00:00.000Z', prerequisites: ['L21'] },
  { serialId: 'E22', unlockAt: '2019-11-04T16:00:00.000Z', prerequisites: ['L22'] },
  { serialId: 'L23', unlockAt: '2019-11-05T16:00:00.000Z', prerequisites: ['L22'] },
  { serialId: 'E23', unlockAt: '2019-11-06T16:00:00.000Z', prerequisites: ['L23'] },
  { serialId: 'L24', unlockAt: '2019-11-10T16:00:00.000Z', prerequisites: ['L23'] },
  { serialId: 'E24', unlockAt: '2019-11-11T16:00:00.000Z', prerequisites: ['L24'] },
  { serialId: 'L25', unlockAt: '2019-11-12T16:00:00.000Z', prerequisites: ['L24'] },
  { serialId: 'E25', unlockAt: '2019-11-13T16:00:00.000Z', prerequisites: ['L25'] },
  { serialId: 'L26', unlockAt: '2019-11-17T16:00:00.000Z', prerequisites: ['L25'] },
  { serialId: 'E26', unlockAt: '2019-11-18T16:00:00.000Z', prerequisites: ['L26'] },
  { serialId: 'L27', unlockAt: '2019-11-19T16:00:00.000Z', prerequisites: ['L26'] },
  { serialId: 'E27', unlockAt: '2019-11-20T16:00:00.000Z', prerequisites: ['L27'] },
  { serialId: 'L28', unlockAt: '2019-11-24T16:00:00.000Z', prerequisites: ['L27'] },
  { serialId: 'E28', unlockAt: '2019-11-25T16:00:00.000Z', prerequisites: ['L28'] },
  { serialId: 'L29', unlockAt: '2019-11-26T16:00:00.000Z', prerequisites: ['L28'] },
  { serialId: 'E29', unlockAt: '2019-11-27T16:00:00.000Z', prerequisites: ['L29'] },
  { serialId: 'L30', unlockAt: '2019-12-01T16:00:00.000Z', prerequisites: ['L29'] },
  { serialId: 'E30', unlockAt: '2019-12-02T16:00:00.000Z', prerequisites: ['L30'] },
  { serialId: 'L31', unlockAt: '2019-12-03T16:00:00.000Z', prerequisites: ['L30'] },
  { serialId: 'E31', unlockAt: '2019-12-04T16:00:00.000Z', prerequisites: ['L31'] },
  { serialId: 'L32', unlockAt: '2019-12-08T16:00:00.000Z', prerequisites: ['L31'] },
  { serialId: 'E32', unlockAt: '2019-12-09T16:00:00.000Z', prerequisites: ['L32'] },
  { serialId: 'L33', unlockAt: '2019-12-10T16:00:00.000Z', prerequisites: ['L32'] },
  { serialId: 'E33', unlockAt: '2019-12-11T16:00:00.000Z', prerequisites: ['L33'] },
  { serialId: 'L34', unlockAt: '2019-12-15T16:00:00.000Z', prerequisites: ['L33'] },
  { serialId: 'E34', unlockAt: '2019-12-16T16:00:00.000Z', prerequisites: ['L34'] },
  { serialId: 'L35', unlockAt: '2019-12-17T16:00:00.000Z', prerequisites: ['L34'] },
  { serialId: 'E35', unlockAt: '2019-12-18T16:00:00.000Z', prerequisites: ['L35'] },
  { serialId: 'R3', unlockAt: '2019-12-19T16:00:00.000Z', prerequisites: ['L35'] },
  { serialId: 'L36', unlockAt: '2019-12-22T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E36', unlockAt: '2019-12-23T16:00:00.000Z', prerequisites: ['L36'] },
  { serialId: 'L37', unlockAt: '2019-12-24T16:00:00.000Z', prerequisites: ['L36'] },
  { serialId: 'E37', unlockAt: '2019-12-25T16:00:00.000Z', prerequisites: ['L37'] },
  { serialId: 'L38', unlockAt: '2020-01-01T16:00:00.000Z', prerequisites: ['L37'] },
  { serialId: 'E38', unlockAt: '2020-01-02T16:00:00.000Z', prerequisites: ['L38'] },
  { serialId: 'L39', unlockAt: '2020-01-05T16:00:00.000Z', prerequisites: ['L38'] },
  { serialId: 'E39', unlockAt: '2020-01-06T16:00:00.000Z', prerequisites: ['L39'] },
  { serialId: 'L40', unlockAt: '2020-01-07T16:00:00.000Z', prerequisites: ['L39'] },
  { serialId: 'E40', unlockAt: '2020-01-08T16:00:00.000Z', prerequisites: ['L40'] },
  { serialId: 'L41', unlockAt: '2020-01-12T16:00:00.000Z', prerequisites: ['L40'] },
  { serialId: 'E41', unlockAt: '2020-01-13T16:00:00.000Z', prerequisites: ['L41'] },
  { serialId: 'L42', unlockAt: '2020-01-14T16:00:00.000Z', prerequisites: ['L41'] },
  { serialId: 'E42', unlockAt: '2020-01-15T16:00:00.000Z', prerequisites: ['L42'] },
  { serialId: 'L43', unlockAt: '2020-01-19T16:00:00.000Z', prerequisites: ['L42'] },
  { serialId: 'E43', unlockAt: '2020-01-20T16:00:00.000Z', prerequisites: ['L43'] },
  { serialId: 'L44', unlockAt: '2020-01-21T16:00:00.000Z', prerequisites: ['L43'] },
  { serialId: 'E44', unlockAt: '2020-01-22T16:00:00.000Z', prerequisites: ['L44'] },
  { serialId: 'L45', unlockAt: '2020-02-02T16:00:00.000Z', prerequisites: ['L44'] },
  { serialId: 'E45', unlockAt: '2020-02-03T16:00:00.000Z', prerequisites: ['L45'] },
  { serialId: 'L46', unlockAt: '2020-02-04T16:00:00.000Z', prerequisites: ['L45'] },
  { serialId: 'E46', unlockAt: '2020-02-05T16:00:00.000Z', prerequisites: ['L46'] },
  { serialId: 'L47', unlockAt: '2020-02-09T16:00:00.000Z', prerequisites: ['L46'] },
  { serialId: 'E47', unlockAt: '2020-02-10T16:00:00.000Z', prerequisites: ['L47'] },
  { serialId: 'R4', unlockAt: '2020-02-11T16:00:00.000Z', prerequisites: ['L47'] },
  { serialId: 'L48', unlockAt: '2020-02-12T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E48', unlockAt: '2020-02-13T16:00:00.000Z', prerequisites: ['L48'] },
  { serialId: 'L49', unlockAt: '2020-02-16T16:00:00.000Z', prerequisites: ['L48'] },
  { serialId: 'E49', unlockAt: '2020-02-17T16:00:00.000Z', prerequisites: ['L49'] },
  { serialId: 'L50', unlockAt: '2020-02-18T16:00:00.000Z', prerequisites: ['L49'] },
  { serialId: 'E50', unlockAt: '2020-02-19T16:00:00.000Z', prerequisites: ['L50'] },
  { serialId: 'L51', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L50'] },
  { serialId: 'E51', unlockAt: '2020-02-24T16:00:00.000Z', prerequisites: ['L51'] },
  { serialId: 'L52', unlockAt: '2020-02-25T16:00:00.000Z', prerequisites: ['L51'] },
  { serialId: 'E52', unlockAt: '2020-02-26T16:00:00.000Z', prerequisites: ['L52'] },
  { serialId: 'L53', unlockAt: '2020-03-01T16:00:00.000Z', prerequisites: ['L52'] },
  { serialId: 'E53', unlockAt: '2020-03-02T16:00:00.000Z', prerequisites: ['L53'] },
  { serialId: 'R5', unlockAt: '2020-03-03T16:00:00.000Z', prerequisites: ['L53'] },
  { serialId: 'L54', unlockAt: '2020-03-04T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E54', unlockAt: '2020-03-05T16:00:00.000Z', prerequisites: ['L54'] },
  { serialId: 'L55', unlockAt: '2020-03-08T16:00:00.000Z', prerequisites: ['L54'] },
  { serialId: 'E55', unlockAt: '2020-03-09T16:00:00.000Z', prerequisites: ['L55'] },
  { serialId: 'L56', unlockAt: '2020-03-10T16:00:00.000Z', prerequisites: ['L55'] },
  { serialId: 'E56', unlockAt: '2020-03-11T16:00:00.000Z', prerequisites: ['L56'] },
  { serialId: 'L57', unlockAt: '2020-03-15T16:00:00.000Z', prerequisites: ['L56'] },
  { serialId: 'E57', unlockAt: '2020-03-16T16:00:00.000Z', prerequisites: ['L57'] },
  { serialId: 'L58', unlockAt: '2020-03-17T16:00:00.000Z', prerequisites: ['L57'] },
  { serialId: 'E58', unlockAt: '2020-03-18T16:00:00.000Z', prerequisites: ['L58'] },
  { serialId: 'R6', unlockAt: '2020-03-19T16:00:00.000Z', prerequisites: ['L58'] },
  { serialId: 'L59', unlockAt: '2020-03-22T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E59', unlockAt: '2020-03-23T16:00:00.000Z', prerequisites: ['L59'] },
  { serialId: 'L60', unlockAt: '2020-03-24T16:00:00.000Z', prerequisites: ['L59'] },
  { serialId: 'E60', unlockAt: '2020-03-25T16:00:00.000Z', prerequisites: ['L60'] },
  { serialId: 'L61', unlockAt: '2020-03-29T16:00:00.000Z', prerequisites: ['L60'] },
  { serialId: 'E61', unlockAt: '2020-03-30T16:00:00.000Z', prerequisites: ['L61'] },
  { serialId: 'L62', unlockAt: '2020-03-31T16:00:00.000Z', prerequisites: ['L61'] },
  { serialId: 'E62', unlockAt: '2020-04-01T16:00:00.000Z', prerequisites: ['L62'] },
  { serialId: 'L63', unlockAt: '2020-04-05T16:00:00.000Z', prerequisites: ['L62'] },
  { serialId: 'E63', unlockAt: '2020-04-06T16:00:00.000Z', prerequisites: ['L63'] },
  { serialId: 'L64', unlockAt: '2020-04-07T16:00:00.000Z', prerequisites: ['L63'] },
  { serialId: 'E64', unlockAt: '2020-04-08T16:00:00.000Z', prerequisites: ['L64'] },
  { serialId: 'L65', unlockAt: '2020-04-12T16:00:00.000Z', prerequisites: ['L64'] },
  { serialId: 'E65', unlockAt: '2020-04-13T16:00:00.000Z', prerequisites: ['L65'] },
  { serialId: 'L66', unlockAt: '2020-04-14T16:00:00.000Z', prerequisites: ['L65'] },
  { serialId: 'E66', unlockAt: '2020-04-15T16:00:00.000Z', prerequisites: ['L66'] },
  { serialId: 'L67', unlockAt: '2020-04-19T16:00:00.000Z', prerequisites: ['L66'] },
  { serialId: 'E67', unlockAt: '2020-04-20T16:00:00.000Z', prerequisites: ['L67'] },
  { serialId: 'L68', unlockAt: '2020-04-21T16:00:00.000Z', prerequisites: ['L67'] },
  { serialId: 'E68', unlockAt: '2020-04-22T16:00:00.000Z', prerequisites: ['L68'] },
  { serialId: 'R7', unlockAt: '2020-04-23T16:00:00.000Z', prerequisites: ['L68'] },
];

const displayC3 = [
  {
    serialId: 'L1',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L1',
  },
  {
    serialId: 'E1',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L1'],
    displayId: 'E1',
  },
  {
    serialId: 'L2',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L1'],
    displayId: 'L2',
  },
  {
    serialId: 'E2',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L2'],
    displayId: 'E2',
  },
  {
    serialId: 'L3',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L2'],
    displayId: 'L3',
  },
  {
    serialId: 'E3',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L3'],
    displayId: 'E3',
  },
  {
    serialId: 'L4',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L3'],
    displayId: 'L4',
  },
  {
    serialId: 'E4',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L4'],
    displayId: 'E4',
  },
  {
    serialId: 'L5',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L4'],
    displayId: 'L5',
  },
  {
    serialId: 'E5',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L5'],
    displayId: 'E5',
  },
  {
    serialId: 'R1',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L5'],
    displayId: 'R1',
  },
  {
    serialId: 'L6',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L1',
  },
  {
    serialId: 'E6',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L6'],
    displayId: 'E1',
  },
  {
    serialId: 'L7',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L6'],
    displayId: 'L2',
  },
  {
    serialId: 'E7',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L7'],
    displayId: 'E2',
  },
  {
    serialId: 'L8',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L7'],
    displayId: 'L3',
  },
  {
    serialId: 'E8',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L8'],
    displayId: 'E3',
  },
  {
    serialId: 'L9',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L8'],
    displayId: 'L4',
  },
  {
    serialId: 'E9',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L9'],
    displayId: 'E4',
  },
  {
    serialId: 'L10',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L9'],
    displayId: 'L5',
  },
  {
    serialId: 'E10',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L10'],
    displayId: 'E5',
  },
  {
    serialId: 'L11',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L10'],
    displayId: 'L6',
  },
  {
    serialId: 'E11',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L11'],
    displayId: 'E6',
  },
  {
    serialId: 'L12',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L11'],
    displayId: 'L7',
  },
  {
    serialId: 'E12',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L12'],
    displayId: 'E7',
  },
  {
    serialId: 'L13',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L12'],
    displayId: 'L8',
  },
  {
    serialId: 'E13',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L13'],
    displayId: 'E8',
  },
  {
    serialId: 'L14',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L13'],
    displayId: 'L9',
  },
  {
    serialId: 'E14',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L14'],
    displayId: 'E9',
  },
  {
    serialId: 'L15',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L14'],
    displayId: 'L10',
  },
  {
    serialId: 'E15',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L15'],
    displayId: 'E10',
  },
  {
    serialId: 'R2',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L15'],
    displayId: 'R2',
  },
  {
    serialId: 'L16',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L1',
  },
  {
    serialId: 'E16',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L16'],
    displayId: 'E1',
  },
  {
    serialId: 'L17',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L16'],
    displayId: 'L2',
  },
  {
    serialId: 'E17',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L17'],
    displayId: 'E2',
  },
  {
    serialId: 'L18',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L17'],
    displayId: 'L3',
  },
  {
    serialId: 'E18',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L18'],
    displayId: 'E3',
  },
  {
    serialId: 'L19',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L18'],
    displayId: 'L4',
  },
  {
    serialId: 'E19',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L19'],
    displayId: 'E4',
  },
  {
    serialId: 'L20',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L19'],
    displayId: 'L5',
  },
  {
    serialId: 'E20',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L20'],
    displayId: 'E5',
  },
  {
    serialId: 'L21',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L20'],
    displayId: 'L6',
  },
  {
    serialId: 'E21',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L21'],
    displayId: 'E6',
  },
  {
    serialId: 'L22',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L21'],
    displayId: 'L7',
  },
  {
    serialId: 'E22',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L22'],
    displayId: 'E7',
  },
  {
    serialId: 'L23',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L22'],
    displayId: 'L8',
  },
  {
    serialId: 'E23',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L23'],
    displayId: 'E8',
  },
  {
    serialId: 'L24',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L23'],
    displayId: 'L9',
  },
  {
    serialId: 'E24',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L24'],
    displayId: 'E9',
  },
  {
    serialId: 'L25',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L24'],
    displayId: 'L10',
  },
  {
    serialId: 'E25',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L25'],
    displayId: 'E10',
  },
  {
    serialId: 'L26',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L25'],
    displayId: 'L11',
  },
  {
    serialId: 'E26',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L26'],
    displayId: 'E11',
  },
  {
    serialId: 'L27',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L26'],
    displayId: 'L12',
  },
  {
    serialId: 'E27',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L27'],
    displayId: 'E12',
  },
  {
    serialId: 'L28',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L27'],
    displayId: 'L13',
  },
  {
    serialId: 'E28',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L28'],
    displayId: 'E13',
  },
  {
    serialId: 'L29',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L28'],
    displayId: 'L14',
  },
  {
    serialId: 'E29',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L29'],
    displayId: 'E14',
  },
  {
    serialId: 'L30',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L29'],
    displayId: 'L15',
  },
  {
    serialId: 'E30',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L30'],
    displayId: 'E15',
  },
  {
    serialId: 'L31',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L30'],
    displayId: 'L16',
  },
  {
    serialId: 'E31',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L31'],
    displayId: 'E16',
  },
  {
    serialId: 'L32',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L31'],
    displayId: 'L17',
  },
  {
    serialId: 'E32',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L32'],
    displayId: 'E17',
  },
  {
    serialId: 'L33',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L32'],
    displayId: 'L18',
  },
  {
    serialId: 'E33',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L33'],
    displayId: 'E18',
  },
  {
    serialId: 'L34',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L33'],
    displayId: 'L19',
  },
  {
    serialId: 'E34',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L34'],
    displayId: 'E19',
  },
  {
    serialId: 'L35',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L34'],
    displayId: 'L20',
  },
  {
    serialId: 'E35',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L35'],
    displayId: 'E20',
  },
  {
    serialId: 'R3',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L35'],
    displayId: 'R3',
  },
  {
    serialId: 'L36',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L1',
  },
  {
    serialId: 'E36',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L36'],
    displayId: 'E1',
  },
  {
    serialId: 'L37',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L36'],
    displayId: 'L2',
  },
  {
    serialId: 'E37',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L37'],
    displayId: 'E2',
  },
  {
    serialId: 'L38',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L37'],
    displayId: 'L3',
  },
  {
    serialId: 'E38',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L38'],
    displayId: 'E3',
  },
  {
    serialId: 'L39',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L38'],
    displayId: 'L4',
  },
  {
    serialId: 'E39',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L39'],
    displayId: 'E4',
  },
  {
    serialId: 'L40',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L39'],
    displayId: 'L5',
  },
  {
    serialId: 'E40',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L40'],
    displayId: 'E5',
  },
  {
    serialId: 'L41',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L40'],
    displayId: 'L6',
  },
  {
    serialId: 'E41',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L41'],
    displayId: 'E6',
  },
  {
    serialId: 'L42',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L41'],
    displayId: 'L7',
  },
  {
    serialId: 'E42',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L42'],
    displayId: 'E7',
  },
  {
    serialId: 'L43',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L42'],
    displayId: 'L8',
  },
  {
    serialId: 'E43',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L43'],
    displayId: 'E8',
  },
  {
    serialId: 'L44',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L43'],
    displayId: 'L9',
  },
  {
    serialId: 'E44',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L44'],
    displayId: 'E9',
  },
  {
    serialId: 'L45',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L44'],
    displayId: 'L10',
  },
  {
    serialId: 'E45',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L45'],
    displayId: 'E10',
  },
  {
    serialId: 'L46',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L45'],
    displayId: 'L11',
  },
  {
    serialId: 'E46',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L46'],
    displayId: 'E11',
  },
  {
    serialId: 'L47',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L46'],
    displayId: 'L12',
  },
  {
    serialId: 'E47',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L47'],
    displayId: 'E12',
  },
  {
    serialId: 'R4',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L47'],
    displayId: 'R4',
  },
  {
    serialId: 'L48',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L1',
  },
  {
    serialId: 'E48',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L48'],
    displayId: 'E1',
  },
  {
    serialId: 'L49',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L48'],
    displayId: 'L2',
  },
  {
    serialId: 'E49',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L49'],
    displayId: 'E2',
  },
  {
    serialId: 'L50',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L49'],
    displayId: 'L3',
  },
  {
    serialId: 'E50',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L50'],
    displayId: 'E3',
  },
  {
    serialId: 'L51',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L50'],
    displayId: 'L4',
  },
  {
    serialId: 'E51',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L51'],
    displayId: 'E4',
  },
  {
    serialId: 'L52',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L51'],
    displayId: 'L5',
  },
  {
    serialId: 'E52',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L52'],
    displayId: 'E5',
  },
  {
    serialId: 'L53',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L52'],
    displayId: 'L6',
  },
  {
    serialId: 'E53',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L53'],
    displayId: 'E6',
  },
  {
    serialId: 'R5',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L53'],
    displayId: 'R5',
  },
  {
    serialId: 'L54',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L1',
  },
  {
    serialId: 'E54',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L54'],
    displayId: 'E1',
  },
  {
    serialId: 'L55',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L54'],
    displayId: 'L2',
  },
  {
    serialId: 'E55',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L55'],
    displayId: 'E2',
  },
  {
    serialId: 'L56',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L55'],
    displayId: 'L3',
  },
  {
    serialId: 'E56',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L56'],
    displayId: 'E3',
  },
  {
    serialId: 'L57',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L56'],
    displayId: 'L4',
  },
  {
    serialId: 'E57',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L57'],
    displayId: 'E4',
  },
  {
    serialId: 'L58',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L57'],
    displayId: 'L5',
  },
  {
    serialId: 'E58',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L58'],
    displayId: 'E5',
  },
  {
    serialId: 'R6',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L58'],
    displayId: 'R6',
  },
  {
    serialId: 'L59',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L1',
  },
  {
    serialId: 'E59',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L59'],
    displayId: 'E1',
  },
  {
    serialId: 'L60',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L59'],
    displayId: 'L2',
  },
  {
    serialId: 'E60',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L60'],
    displayId: 'E2',
  },
  {
    serialId: 'L61',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L60'],
    displayId: 'L3',
  },
  {
    serialId: 'E61',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L61'],
    displayId: 'E3',
  },
  {
    serialId: 'L62',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L61'],
    displayId: 'L4',
  },
  {
    serialId: 'E62',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L62'],
    displayId: 'E4',
  },
  {
    serialId: 'L63',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L62'],
    displayId: 'L5',
  },
  {
    serialId: 'E63',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L63'],
    displayId: 'E5',
  },
  {
    serialId: 'L64',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L63'],
    displayId: 'L6',
  },
  {
    serialId: 'E64',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L64'],
    displayId: 'E6',
  },
  {
    serialId: 'L65',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L64'],
    displayId: 'L7',
  },
  {
    serialId: 'E65',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L65'],
    displayId: 'E7',
  },
  {
    serialId: 'L66',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L65'],
    displayId: 'L8',
  },
  {
    serialId: 'E66',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L66'],
    displayId: 'E8',
  },
  {
    serialId: 'L67',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L66'],
    displayId: 'L9',
  },
  {
    serialId: 'E67',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L67'],
    displayId: 'E9',
  },
  {
    serialId: 'L68',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L67'],
    displayId: 'L10',
  },
  {
    serialId: 'E68',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L68'],
    displayId: 'E10',
  },
  {
    serialId: 'R7',
    unlockAt: '2020-09-17T16:00:00.000Z',
    prerequisites: ['L68'],
    displayId: 'R7',
  },
];

export const c391 = [
  {
    serialId: 'L391001',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: [],
    displayId: 'L1',
  },
  {
    serialId: 'E391001',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391001'],
    displayId: 'E1',
  },
  {
    serialId: 'L391002',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391001'],
    displayId: 'L2',
  },
  {
    serialId: 'E391002',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391002'],
    displayId: 'E2',
  },
  {
    serialId: 'L391003',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391002'],
    displayId: 'L3',
  },
  {
    serialId: 'E391003',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391003'],
    displayId: 'E3',
  },
  {
    serialId: 'L391004',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391003'],
    displayId: 'L4',
  },
  {
    serialId: 'E391004',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391004'],
    displayId: 'E4',
  },
  {
    serialId: 'L391005',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391004'],
    displayId: 'L5',
  },
  {
    serialId: 'E391005',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391005'],
    displayId: 'E5',
  },
  {
    serialId: 'L391006',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391005'],
    displayId: 'L6',
  },
  {
    serialId: 'E391006',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391006'],
    displayId: 'E6',
  },
  {
    serialId: 'L391007',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391006'],
    displayId: 'L7',
  },
  {
    serialId: 'E391007',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391007'],
    displayId: 'E7',
  },
  {
    serialId: 'L391008',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391007'],
    displayId: 'L8',
  },
  {
    serialId: 'E391008',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391008'],
    displayId: 'E8',
  },
  {
    serialId: 'L391009',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391008'],
    displayId: 'L9',
  },
  {
    serialId: 'E391009',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391009'],
    displayId: 'E9',
  },
  {
    serialId: 'L391010',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391009'],
    displayId: 'L10',
  },
  {
    serialId: 'E391010',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391010'],
    displayId: 'E10',
  },
  {
    serialId: 'L391011',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391010'],
    displayId: 'L11',
  },
  {
    serialId: 'E391011',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391011'],
    displayId: 'E11',
  },
  {
    serialId: 'L391012',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391011'],
    displayId: 'L12',
  },
  {
    serialId: 'E391012',
    unlockAt: '2019-09-17T06:27:18.948Z',
    prerequisites: ['L391012'],
    displayId: 'E12',
  },
  ...displayC3,
];
export const c392 = [
  {
    serialId: 'L392001',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'L1',
  },
  {
    serialId: 'E392001',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'E1',
  },
  {
    serialId: 'L392002',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'L2',
  },
  {
    serialId: 'E392002',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'E2',
  },
  {
    serialId: 'L392003',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'L3',
  },
  {
    serialId: 'E392003',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'E3',
  },
  {
    serialId: 'L392004',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L4',
  },
  {
    serialId: 'E392004',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392004'],
    displayId: 'E4',
  },
  {
    serialId: 'L392005',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392004'],
    displayId: 'L5',
  },
  {
    serialId: 'E392005',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392005'],
    displayId: 'E5',
  },
  {
    serialId: 'L392006',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392005'],
    displayId: 'L6',
  },
  {
    serialId: 'E392006',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392006'],
    displayId: 'E6',
  },
  {
    serialId: 'L392007',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392006'],
    displayId: 'L7',
  },
  {
    serialId: 'E392007',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392007'],
    displayId: 'E7',
  },
  {
    serialId: 'L392008',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392007'],
    displayId: 'L8',
  },
  {
    serialId: 'E392008',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392008'],
    displayId: 'E8',
  },
  {
    serialId: 'L392009',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392008'],
    displayId: 'L9',
  },
  {
    serialId: 'E392009',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392009'],
    displayId: 'E9',
  },
  {
    serialId: 'L392010',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392009'],
    displayId: 'L10',
  },
  {
    serialId: 'E392010',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392010'],
    displayId: 'E10',
  },
  {
    serialId: 'L392011',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392010'],
    displayId: 'L11',
  },
  {
    serialId: 'E392011',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392011'],
    displayId: 'E11',
  },
  {
    serialId: 'L392012',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392011'],
    displayId: 'L12',
  },
  {
    serialId: 'E392012',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L392012'],
    displayId: 'E12',
  },
  ...displayC3,
];
export const c393 = [
  {
    serialId: 'L393001',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'L1',
  },
  {
    serialId: 'E393001',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'E1',
  },
  {
    serialId: 'L393002',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'L2',
  },
  {
    serialId: 'E393002',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'E2',
  },
  {
    serialId: 'L393003',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'L3',
  },
  {
    serialId: 'E393003',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'E3',
  },
  {
    serialId: 'L393004',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'L4',
  },
  {
    serialId: 'E393004',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'E4',
  },
  {
    serialId: 'L393005',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'L5',
  },
  {
    serialId: 'E393005',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    status: 4,
    displayId: 'E5',
  },
  {
    serialId: 'L393006',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L6',
  },
  {
    serialId: 'E393006',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393006'],
    displayId: 'E6',
  },
  {
    serialId: 'L393007',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393006'],
    displayId: 'L7',
  },
  {
    serialId: 'E393007',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393007'],
    displayId: 'E7',
  },
  {
    serialId: 'L393008',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393007'],
    displayId: 'L8',
  },
  {
    serialId: 'E393008',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393008'],
    displayId: 'E8',
  },
  {
    serialId: 'L393009',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393008'],
    displayId: 'L9',
  },
  {
    serialId: 'E393009',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393009'],
    displayId: 'E9',
  },
  {
    serialId: 'L393010',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393009'],
    displayId: 'L10',
  },
  {
    serialId: 'E393010',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393010'],
    displayId: 'E10',
  },
  {
    serialId: 'L393011',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393010'],
    displayId: 'L11',
  },
  {
    serialId: 'E393011',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393011'],
    displayId: 'E11',
  },
  {
    serialId: 'L393012',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393011'],
    displayId: 'L12',
  },
  {
    serialId: 'E393012',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L393012'],
    displayId: 'E12',
  },
  ...displayC3,
];

export const c200 = [
  {
    serialId: 'L301',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: [],
    displayId: 'L1',
  },
  {
    serialId: 'E301',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L301'],
    displayId: 'E1',
  },
  {
    serialId: 'L302',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L301'],
    displayId: 'L2',
  },
  {
    serialId: 'E302',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L302'],
    displayId: 'E2',
  },
  {
    serialId: 'L303',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L302'],
    displayId: 'L3',
  },
  {
    serialId: 'E303',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L303'],
    displayId: 'E3',
  },
  {
    serialId: 'L304',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L303'],
    displayId: 'L4',
  },
  {
    serialId: 'E304',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L304'],
    displayId: 'E4',
  },
  {
    serialId: 'L305',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L304'],
    displayId: 'L5',
  },
  {
    serialId: 'E305',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L305'],
    displayId: 'E5',
  },
  {
    serialId: 'L30301',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L305'],
    displayId: 'L6',
  },
  {
    serialId: 'E30301',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L30301'],
    displayId: 'E6',
  },
  {
    serialId: 'L31001',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L30301'],
    displayId: 'L7',
  },
  {
    serialId: 'E31001',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L31001'],
    displayId: 'E7',
  },
  {
    serialId: 'L30401',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L31001'],
    displayId: 'L8',
  },
  {
    serialId: 'E30401',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L30401'],
    displayId: 'E8',
  },
  {
    serialId: 'L306',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L30401'],
    displayId: 'L9',
  },
  {
    serialId: 'E306',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L306'],
    displayId: 'E9',
  },
  {
    serialId: 'L307',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L306'],
    displayId: 'L10',
  },
  {
    serialId: 'E307',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L307'],
    displayId: 'E10',
  },
  {
    serialId: 'L308',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L307'],
    displayId: 'L11',
  },
  {
    serialId: 'E308',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L308'],
    displayId: 'E11',
  },
  {
    serialId: 'L30801',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L308'],
    displayId: 'L12',
  },
  {
    serialId: 'E30801',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L30801'],
    displayId: 'E12',
  },
  {
    serialId: 'L309',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L30801'],
    displayId: 'L13',
  },
  {
    serialId: 'E309',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L309'],
    displayId: 'E13',
  },
  {
    serialId: 'L3010',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L309'],
    displayId: 'L14',
  },
  {
    serialId: 'E3010',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3010'],
    displayId: 'E14',
  },
  {
    serialId: 'L3011',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3010'],
    displayId: 'L15',
  },
  {
    serialId: 'E3011',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3011'],
    displayId: 'E15',
  },
  {
    serialId: 'L3012',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3011'],
    displayId: 'L16',
  },
  {
    serialId: 'E3012',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3012'],
    displayId: 'E16',
  },
  {
    serialId: 'L3013',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3012'],
    displayId: 'L17',
  },
  {
    serialId: 'E3013',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3013'],
    displayId: 'E17',
  },
  {
    serialId: 'L3014',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3013'],
    displayId: 'L18',
  },
  {
    serialId: 'E3014',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3014'],
    displayId: 'E18',
  },
  {
    serialId: 'L31501',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3014'],
    displayId: 'L19',
  },
  {
    serialId: 'E31501',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L31501'],
    displayId: 'E19',
  },
  {
    serialId: 'L3015',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L31501'],
    displayId: 'L20',
  },
  {
    serialId: 'E3015',
    unlockAt: '2018-11-26T16:00:00.000Z',
    prerequisites: ['L3015'],
    displayId: 'E20',
  },
];

export const c216 = [
  {
    serialId: 'L301',
    unlockAt: '2019-10-03T16:00:00.000Z',
    prerequisites: [],
    groupIndex: 1,
    displayId: 'L1',
  },
  {
    serialId: 'E301',
    unlockAt: '2019-10-04T16:00:00.000Z',
    prerequisites: ['L301'],
    groupIndex: 1,
    displayId: 'E1',
  },
  {
    serialId: 'L302',
    unlockAt: '2019-10-05T16:00:00.000Z',
    prerequisites: ['L301'],
    displayId: 'L2',
    groupIndex: 1,
  },
  {
    serialId: 'E302',
    unlockAt: '2019-10-06T16:00:00.000Z',
    prerequisites: ['L302'],
    displayId: 'E2',
    groupIndex: 1,
  },
  {
    serialId: 'L303',
    unlockAt: '2019-10-10T16:00:00.000Z',
    prerequisites: ['L302'],
    displayId: 'L3',
    groupIndex: 1,
  },
  {
    serialId: 'E303',
    unlockAt: '2019-10-11T16:00:00.000Z',
    prerequisites: ['L303'],
    displayId: 'E3',
    groupIndex: 1,
  },
  {
    serialId: 'L304',
    unlockAt: '2019-10-12T16:00:00.000Z',
    prerequisites: ['L303'],
    displayId: 'L4',
    groupIndex: 1,
  },
  {
    serialId: 'E304',
    unlockAt: '2019-10-13T16:00:00.000Z',
    prerequisites: ['L304'],
    displayId: 'E4',
    groupIndex: 1,
  },
  {
    serialId: 'L305',
    unlockAt: '2019-10-17T16:00:00.000Z',
    prerequisites: ['L304'],
    displayId: 'L5',
    groupIndex: 1,
  },
  {
    serialId: 'E305',
    unlockAt: '2019-10-18T16:00:00.000Z',
    prerequisites: ['L305'],
    displayId: 'E5',
    groupIndex: 1,
  },
  {
    serialId: 'L31001',
    unlockAt: '2019-10-24T16:00:00.000Z',
    prerequisites: ['L305'],
    displayId: 'L6',
    groupIndex: 1,
  },
  {
    serialId: 'E31001',
    unlockAt: '2019-10-25T16:00:00.000Z',
    prerequisites: ['L31001'],
    displayId: 'E6',
    groupIndex: 1,
  },
  {
    serialId: 'L30401',
    unlockAt: '2019-10-26T16:00:00.000Z',
    prerequisites: ['L31001'],
    displayId: 'L7',
    groupIndex: 1,
  },
  {
    serialId: 'E30401',
    unlockAt: '2019-10-27T16:00:00.000Z',
    prerequisites: ['L30401'],
    displayId: 'E7',
    groupIndex: 1,
  },
  {
    serialId: 'L306',
    unlockAt: '2019-10-01T16:00:00.000Z',
    prerequisites: ['L30401'],
    displayId: 'L8',
    groupIndex: 1,
  },
  {
    serialId: 'E306',
    unlockAt: '2019-10-02T16:00:00.000Z',
    prerequisites: ['L306'],
    displayId: 'E8',
    groupIndex: 1,
  },
  {
    serialId: 'L307',
    unlockAt: '2019-10-03T16:00:00.000Z',
    prerequisites: ['L306'],
    displayId: 'L9',
    groupIndex: 1,
  },
  {
    serialId: 'E307',
    unlockAt: '2019-10-04T16:00:00.000Z',
    prerequisites: ['L307'],
    displayId: 'E9',
    groupIndex: 1,
  },
  {
    serialId: 'L308',
    unlockAt: '2019-10-08T16:00:00.000Z',
    prerequisites: ['L307'],
    displayId: 'L10',
    groupIndex: 1,
  },
  {
    serialId: 'E308',
    unlockAt: '2019-10-09T16:00:00.000Z',
    prerequisites: ['L308'],
    displayId: 'E10',
    groupIndex: 1,
  },
  {
    serialId: 'L30801',
    unlockAt: '2019-10-10T16:00:00.000Z',
    prerequisites: ['L308'],
    displayId: 'L11',
    groupIndex: 1,
  },
  {
    serialId: 'E30801',
    unlockAt: '2019-10-11T16:00:00.000Z',
    prerequisites: ['L30801'],
    displayId: 'E11',
    groupIndex: 1,
  },
  {
    serialId: 'L3012',
    unlockAt: '2019-10-24T16:00:00.000Z',
    prerequisites: ['L30801'],
    displayId: 'L12',
    groupIndex: 1,
  },
  {
    serialId: 'E3012',
    unlockAt: '2019-10-25T16:00:00.000Z',
    prerequisites: ['L3012'],
    displayId: 'E12',
    groupIndex: 1,
  },
  {
    serialId: 'L3013',
    unlockAt: '2019-10-29T16:00:00.000Z',
    prerequisites: ['L3012'],
    displayId: 'L13',
    groupIndex: 1,
  },
  {
    serialId: 'E3013',
    unlockAt: '2019-10-30T16:00:00.000Z',
    prerequisites: ['L3013'],
    displayId: 'E13',
    groupIndex: 1,
  },
  {
    serialId: 'L3014',
    unlockAt: '2019-10-01T16:00:00.000Z',
    prerequisites: ['L3013'],
    displayId: 'L14',
    groupIndex: 1,
  },
  {
    serialId: 'E3014',
    unlockAt: '2019-10-02T16:00:00.000Z',
    prerequisites: ['L3014'],
    displayId: 'E14',
    groupIndex: 1,
  },
  {
    serialId: 'L31501',
    unlockAt: '2019-10-05T16:00:00.000Z',
    prerequisites: ['L3014'],
    displayId: 'L15',
    groupIndex: 1,
  },
  {
    serialId: 'E31501',
    unlockAt: '2019-10-06T16:00:00.000Z',
    prerequisites: ['L31501'],
    displayId: 'E15',
    groupIndex: 1,
  },
  {
    serialId: 'L3015',
    unlockAt: '2019-10-07T16:00:00.000Z',
    prerequisites: ['L31501'],
    displayId: 'L16',
    groupIndex: 1,
  },
  {
    serialId: 'E3015',
    unlockAt: '2019-10-08T16:00:00.000Z',
    prerequisites: ['L3015'],
    displayId: 'E16',
    groupIndex: 1,
  },
];

export const c31 = [
  {
    serialId: 'L304',
    displayId: 'L1',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
  },
  {
    serialId: 'E304',
    displayId: 'E1',
    unlockAt: '2019-08-05T16:00:00.000Z',
    prerequisites: ['L304'],
  },
  {
    serialId: 'L305',
    displayId: 'L2',
    unlockAt: '2019-08-06T16:00:00.000Z',
    prerequisites: ['L304'],
  },
  {
    serialId: 'E305',
    displayId: 'E2',
    unlockAt: '2019-08-07T16:00:00.000Z',
    prerequisites: ['L305'],
  },
  {
    serialId: 'L30301',
    displayId: 'L3',
    unlockAt: '2019-08-11T16:00:00.000Z',
    prerequisites: ['L305'],
  },
  {
    serialId: 'E30301',
    displayId: 'E3',
    unlockAt: '2019-08-12T16:00:00.000Z',
    prerequisites: ['L30301'],
  },
  {
    serialId: 'L30401',
    displayId: 'L4',
    unlockAt: '2019-08-13T16:00:00.000Z',
    prerequisites: ['L30301'],
  },
  {
    serialId: 'E30401',
    displayId: 'E4',
    unlockAt: '2019-08-14T16:00:00.000Z',
    prerequisites: ['L30401'],
  },
  {
    serialId: 'L306',
    displayId: 'L5',
    unlockAt: '2019-08-18T16:00:00.000Z',
    prerequisites: ['L30401'],
  },
  {
    serialId: 'E306',
    displayId: 'E5',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L306'],
  },
  {
    serialId: 'L307',
    displayId: 'L6',
    unlockAt: '2019-08-20T16:00:00.000Z',
    prerequisites: ['L306'],
  },
  {
    serialId: 'E307',
    displayId: 'E6',
    unlockAt: '2019-08-21T16:00:00.000Z',
    prerequisites: ['L307'],
  },
  {
    serialId: 'L308',
    displayId: 'L7',
    unlockAt: '2019-08-25T16:00:00.000Z',
    prerequisites: ['L307'],
  },
  {
    serialId: 'E308',
    displayId: 'E7',
    unlockAt: '2019-08-26T16:00:00.000Z',
    prerequisites: ['L308'],
  },
  {
    serialId: 'L30801',
    displayId: 'L8',
    unlockAt: '2019-08-27T16:00:00.000Z',
    prerequisites: ['L308'],
  },
  {
    serialId: 'E30801',
    displayId: 'E8',
    unlockAt: '2019-08-28T16:00:00.000Z',
    prerequisites: ['L30801'],
  },
  {
    serialId: 'L309',
    displayId: 'L9',
    unlockAt: '2019-09-01T16:00:00.000Z',
    prerequisites: ['L30801'],
  },
  {
    serialId: 'E309',
    displayId: 'E9',
    unlockAt: '2019-09-02T16:00:00.000Z',
    prerequisites: ['L309'],
  },
  {
    serialId: 'L31001',
    displayId: 'L10',
    unlockAt: '2019-09-03T16:00:00.000Z',
    prerequisites: ['L309'],
  },
  {
    serialId: 'E31001',
    displayId: 'E10',
    unlockAt: '2019-09-04T16:00:00.000Z',
    prerequisites: ['L31001'],
  },
  {
    serialId: 'L3011',
    displayId: 'L11',
    unlockAt: '2019-09-08T16:00:00.000Z',
    prerequisites: ['L31001'],
  },
  {
    serialId: 'E3011',
    displayId: 'E11',
    unlockAt: '2019-09-09T16:00:00.000Z',
    prerequisites: ['L3011'],
  },
  {
    serialId: 'L3012',
    displayId: 'L12',
    unlockAt: '2019-09-10T16:00:00.000Z',
    prerequisites: ['L3011'],
  },
  {
    serialId: 'E3012',
    displayId: 'E12',
    unlockAt: '2019-09-11T16:00:00.000Z',
    prerequisites: ['L3012'],
  },
  {
    serialId: 'L3013',
    displayId: 'L13',
    unlockAt: '2019-09-15T16:00:00.000Z',
    prerequisites: ['L3012'],
  },
  {
    serialId: 'E3013',
    displayId: 'E13',
    unlockAt: '2019-09-16T16:00:00.000Z',
    prerequisites: ['L3013'],
  },
  {
    serialId: 'L3014',
    displayId: 'L14',
    unlockAt: '2019-09-17T16:00:00.000Z',
    prerequisites: ['L3013'],
  },
  {
    serialId: 'E3014',
    displayId: 'E14',
    unlockAt: '2019-09-18T16:00:00.000Z',
    prerequisites: ['L3014'],
  },
  {
    serialId: 'L31501',
    displayId: 'L15',
    unlockAt: '2019-09-22T16:00:00.000Z',
    prerequisites: ['L3014'],
  },
  {
    serialId: 'E31501',
    displayId: 'E15',
    unlockAt: '2019-09-23T16:00:00.000Z',
    prerequisites: ['L31501'],
  },
  {
    serialId: 'L3015',
    displayId: 'L16',
    unlockAt: '2019-09-24T16:00:00.000Z',
    prerequisites: ['L31501'],
  },
  {
    serialId: 'E3015',
    displayId: 'E16',
    unlockAt: '2019-09-25T16:00:00.000Z',
    prerequisites: ['L3015'],
  },
  ...displayC3,
];

export const c32 = [
  {
    serialId: 'L301',
    displayId: 'L1',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'E301',
    displayId: 'E1',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'L302',
    displayId: 'L2',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'E302',
    displayId: 'E2',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'L303',
    displayId: 'L3',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'E303',
    displayId: 'E3',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'L30402',
    displayId: 'L4',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
  },
  {
    serialId: 'E30402',
    displayId: 'E4',
    unlockAt: '2019-08-05T16:00:00.000Z',
    prerequisites: ['L30402'],
  },
  {
    serialId: 'L306',
    displayId: 'L5',
    unlockAt: '2019-08-06T16:00:00.000Z',
    prerequisites: ['L30402'],
  },
  {
    serialId: 'E306',
    displayId: 'E5',
    unlockAt: '2019-08-07T16:00:00.000Z',
    prerequisites: ['L306'],
  },
  {
    serialId: 'L307',
    displayId: 'L6',
    unlockAt: '2019-08-11T16:00:00.000Z',
    prerequisites: ['L306'],
  },
  {
    serialId: 'E307',
    displayId: 'E6',
    unlockAt: '2019-08-12T16:00:00.000Z',
    prerequisites: ['L307'],
  },
  {
    serialId: 'L308',
    displayId: 'L7',
    unlockAt: '2019-08-13T16:00:00.000Z',
    prerequisites: ['L307'],
  },
  {
    serialId: 'E308',
    displayId: 'E7',
    unlockAt: '2019-08-14T16:00:00.000Z',
    prerequisites: ['L308'],
  },
  {
    serialId: 'L30802',
    displayId: 'L8',
    unlockAt: '2019-08-18T16:00:00.000Z',
    prerequisites: ['L308'],
  },
  {
    serialId: 'E30802',
    displayId: 'E8',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L30802'],
  },
  {
    serialId: 'L309',
    displayId: 'L9',
    unlockAt: '2019-08-20T16:00:00.000Z',
    prerequisites: ['L30802'],
  },
  {
    serialId: 'E309',
    displayId: 'E9',
    unlockAt: '2019-08-21T16:00:00.000Z',
    prerequisites: ['L309'],
  },
  {
    serialId: 'L3010',
    displayId: 'L10',
    unlockAt: '2019-08-25T16:00:00.000Z',
    prerequisites: ['L309'],
  },
  {
    serialId: 'E3010',
    displayId: 'E10',
    unlockAt: '2019-08-26T16:00:00.000Z',
    prerequisites: ['L3010'],
  },
  {
    serialId: 'L3011',
    displayId: 'L11',
    unlockAt: '2019-08-27T16:00:00.000Z',
    prerequisites: ['L3010'],
  },
  {
    serialId: 'E3011',
    displayId: 'E11',
    unlockAt: '2019-08-28T16:00:00.000Z',
    prerequisites: ['L3011'],
  },
  {
    serialId: 'L3012',
    displayId: 'L12',
    unlockAt: '2019-09-01T16:00:00.000Z',
    prerequisites: ['L3011'],
  },
  {
    serialId: 'E3012',
    displayId: 'E12',
    unlockAt: '2019-09-02T16:00:00.000Z',
    prerequisites: ['L3012'],
  },
  {
    serialId: 'L3013',
    displayId: 'L13',
    unlockAt: '2019-09-03T16:00:00.000Z',
    prerequisites: ['L3012'],
  },
  {
    serialId: 'E3013',
    displayId: 'E13',
    unlockAt: '2019-09-04T16:00:00.000Z',
    prerequisites: ['L3013'],
  },
  {
    serialId: 'L3014',
    displayId: 'L14',
    unlockAt: '2019-09-08T16:00:00.000Z',
    prerequisites: ['L3013'],
  },
  {
    serialId: 'E3014',
    displayId: 'E14',
    unlockAt: '2019-09-09T16:00:00.000Z',
    prerequisites: ['L3014'],
  },
  {
    serialId: 'L31502',
    displayId: 'L15',
    unlockAt: '2019-09-10T16:00:00.000Z',
    prerequisites: ['L3014'],
  },
  {
    serialId: 'E31502',
    displayId: 'E15',
    unlockAt: '2019-09-11T16:00:00.000Z',
    prerequisites: ['L31502'],
  },
  {
    serialId: 'L3015',
    displayId: 'L16',
    unlockAt: '2019-09-15T16:00:00.000Z',
    prerequisites: ['L31502'],
  },
  {
    serialId: 'E3015',
    displayId: 'E16',
    unlockAt: '2019-09-16T16:00:00.000Z',
    prerequisites: ['L3015'],
  },
  ...displayC3,
];

export const c33 = [
  {
    serialId: 'L30103',
    displayId: 'L1',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'E30103',
    displayId: 'E1',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'L30203',
    displayId: 'L2',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'E30203',
    displayId: 'E2',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'L30303',
    displayId: 'L3',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'E30303',
    displayId: 'E3',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'L304',
    displayId: 'L4',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'E304',
    displayId: 'E4',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'L305',
    displayId: 'L5',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'E305',
    displayId: 'E5',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
    status: 4,
  },
  {
    serialId: 'L30603',
    displayId: 'L6',
    unlockAt: '2019-08-04T16:00:00.000Z',
    prerequisites: [],
  },
  {
    serialId: 'E30603',
    displayId: 'E6',
    unlockAt: '2019-08-05T16:00:00.000Z',
    prerequisites: ['L30603'],
  },
  {
    serialId: 'L30703',
    displayId: 'L7',
    unlockAt: '2019-08-06T16:00:00.000Z',
    prerequisites: ['L30603'],
  },
  {
    serialId: 'E30703',
    displayId: 'E7',
    unlockAt: '2019-08-07T16:00:00.000Z',
    prerequisites: ['L30703'],
  },
  {
    serialId: 'L3010',
    displayId: 'L8',
    unlockAt: '2019-08-11T16:00:00.000Z',
    prerequisites: ['L30703'],
  },
  {
    serialId: 'E3010',
    displayId: 'E8',
    unlockAt: '2019-08-12T16:00:00.000Z',
    prerequisites: ['L3010'],
  },
  {
    serialId: 'L30903',
    displayId: 'L9',
    unlockAt: '2019-08-13T16:00:00.000Z',
    prerequisites: ['L3010'],
  },
  {
    serialId: 'E30903',
    displayId: 'E9',
    unlockAt: '2019-08-14T16:00:00.000Z',
    prerequisites: ['L30903'],
  },
  {
    serialId: 'L3011',
    displayId: 'L10',
    unlockAt: '2019-08-18T16:00:00.000Z',
    prerequisites: ['L30903'],
  },
  {
    serialId: 'E3011',
    displayId: 'E10',
    unlockAt: '2019-08-19T16:00:00.000Z',
    prerequisites: ['L3011'],
  },
  {
    serialId: 'L3012',
    displayId: 'L11',
    unlockAt: '2019-08-20T16:00:00.000Z',
    prerequisites: ['L3011'],
  },
  {
    serialId: 'E3012',
    displayId: 'E11',
    unlockAt: '2019-08-21T16:00:00.000Z',
    prerequisites: ['L3012'],
  },
  {
    serialId: 'L31203',
    displayId: 'L12',
    unlockAt: '2019-08-25T16:00:00.000Z',
    prerequisites: ['L3012'],
  },
  {
    serialId: 'E31203',
    displayId: 'E12',
    unlockAt: '2019-08-26T16:00:00.000Z',
    prerequisites: ['L31203'],
  },
  {
    serialId: 'L3013',
    displayId: 'L13',
    unlockAt: '2019-08-27T16:00:00.000Z',
    prerequisites: ['L31203'],
  },
  {
    serialId: 'E3013',
    displayId: 'E13',
    unlockAt: '2019-08-28T16:00:00.000Z',
    prerequisites: ['L3013'],
  },
  {
    serialId: 'L3014',
    displayId: 'L14',
    unlockAt: '2019-09-01T16:00:00.000Z',
    prerequisites: ['L3013'],
  },
  {
    serialId: 'E3014',
    displayId: 'E14',
    unlockAt: '2019-09-02T16:00:00.000Z',
    prerequisites: ['L3014'],
  },
  {
    serialId: 'L31503',
    displayId: 'L15',
    unlockAt: '2019-09-03T16:00:00.000Z',
    prerequisites: ['L3014'],
  },
  {
    serialId: 'E31503',
    displayId: 'E15',
    unlockAt: '2019-09-04T16:00:00.000Z',
    prerequisites: ['L31503'],
  },
  {
    serialId: 'L3015',
    displayId: 'L16',
    unlockAt: '2019-09-08T16:00:00.000Z',
    prerequisites: ['L31503'],
  },
  {
    serialId: 'E3015',
    displayId: 'E16',
    unlockAt: '2019-09-09T16:00:00.000Z',
    prerequisites: ['L3015'],
  },
  ...displayC3,
];

const c9x = [
  { serialId: 'L1', unlockAt: '2019-11-17T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E1', unlockAt: '2019-11-18T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'L2', unlockAt: '2019-11-19T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'E2', unlockAt: '2019-11-20T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'L3', unlockAt: '2019-11-24T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'E3', unlockAt: '2019-11-25T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'L4', unlockAt: '2019-11-26T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'E4', unlockAt: '2019-11-27T16:00:00.000Z', prerequisites: ['L4'] },
  { serialId: 'R1', unlockAt: '2019-11-28T16:00:00.000Z', prerequisites: ['L4'] },
];
const c91Plus = [...c9x, ...c991.slice(8)];
const c92Plus = [...c9x, ...c992.slice(8)];
const c93Plus = [...c9x, ...c993.slice(8)];

export const c4 = [
  { serialId: 'L1', unlockAt: '2019-11-17T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E1', unlockAt: '2019-11-18T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'L2', unlockAt: '2019-11-19T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'E2', unlockAt: '2019-11-20T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'L3', unlockAt: '2019-11-24T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'E3', unlockAt: '2019-11-25T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'L4', unlockAt: '2019-11-26T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'E4', unlockAt: '2019-11-27T16:00:00.000Z', prerequisites: ['L4'] },
];

const c51 = [
  { serialId: 'L1', unlockAt: '2019-07-28T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E1', unlockAt: '2019-07-29T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'L2', unlockAt: '2019-07-30T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'E2', unlockAt: '2019-07-31T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'L3', unlockAt: '2019-08-04T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'E3', unlockAt: '2019-08-05T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'L4', unlockAt: '2019-08-06T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'E4', unlockAt: '2019-08-07T16:00:00.000Z', prerequisites: ['L4'] },
  { serialId: 'L5', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L4'] },
  { serialId: 'E5', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L5'] },
  { serialId: 'L6', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L5'] },
  { serialId: 'E6', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L6'] },
  { serialId: 'L7', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L6'] },
  { serialId: 'E7', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L7'] },
  { serialId: 'L8', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L7'] },
  { serialId: 'E8', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L8'] },
  { serialId: 'L9', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L8'] },
  { serialId: 'E9', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L9'] },
  { serialId: 'L10', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L9'] },
  { serialId: 'E10', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L10'] },
  { serialId: 'L11', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L10'] },
  { serialId: 'E11', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L11'] },
  { serialId: 'L12', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L11'] },
  { serialId: 'E12', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L12'] },
  { serialId: 'L13', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L12'] },
  { serialId: 'E13', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L13'] },
  { serialId: 'L14', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L13'] },
  { serialId: 'E14', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L14'] },
  { serialId: 'L15', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L14'] },
  { serialId: 'E15', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L15'] },
  { serialId: 'L16', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L15'] },
  { serialId: 'E16', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L16'] },
  { serialId: 'L17', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L16'] },
  { serialId: 'E17', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L17'] },
  { serialId: 'L18', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: [] },
  { serialId: 'E18', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L18'] },
  { serialId: 'L19', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L18'] },
  { serialId: 'E19', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L19'] },
  { serialId: 'L20', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L19'] },
  { serialId: 'E20', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L20'] },
  { serialId: 'L21', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L20'] },
  { serialId: 'E21', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L21'] },
  { serialId: 'L22', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L21'] },
  { serialId: 'E22', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L22'] },
  { serialId: 'L23', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: [] },
  { serialId: 'E23', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L23'] },
  { serialId: 'L24', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L23'] },
  { serialId: 'E24', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L24'] },
  { serialId: 'L25', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L24'] },
  { serialId: 'E25', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L25'] },
  { serialId: 'L26', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L25'] },
  { serialId: 'E26', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L26'] },
  { serialId: 'L27', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L26'] },
  { serialId: 'E27', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L27'] },
  { serialId: 'L28', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L27'] },
  { serialId: 'E28', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L28'] },
  { serialId: 'L29', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L28'] },
  { serialId: 'E29', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L29'] },
];

const c51Plus = [
  ...c51,
  { serialId: 'L30', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E30', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L30'] },
  { serialId: 'L31', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L30'] },
  { serialId: 'E31', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L31'] },
  { serialId: 'L32', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L31'] },
  { serialId: 'E32', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L32'] },
  { serialId: 'L33', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L32'] },
  { serialId: 'E33', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L33'] },
  { serialId: 'L34', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L33'] },
  { serialId: 'E34', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L34'] },
  { serialId: 'L35', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L34'] },
  { serialId: 'E35', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L35'] },
  { serialId: 'L36', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L35'] },
  { serialId: 'E36', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L36'] },
  { serialId: 'L37', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L36'] },
  { serialId: 'E37', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L37'] },
  { serialId: 'L38', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L37'] },
  { serialId: 'E38', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L38'] },
  { serialId: 'L39', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L38'] },
  { serialId: 'E39', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L39'] },
  { serialId: 'L40', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L39'] },
  { serialId: 'E40', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L40'] },
  { serialId: 'L41', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L40'] },
  { serialId: 'E41', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L41'] },
  { serialId: 'L42', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L41'] },
  { serialId: 'E42', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L42'] },
  { serialId: 'L43', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L42'] },
  { serialId: 'E43', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L43'] },
  { serialId: 'L44', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L43'] },
  { serialId: 'E44', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L44'] },
  { serialId: 'L45', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L44'] },
  { serialId: 'E45', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L45'] },
  { serialId: 'R1', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L45'] },
  { serialId: 'L46', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E46', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L46'] },
  { serialId: 'L47', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L46'] },
  { serialId: 'E47', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L47'] },
  { serialId: 'L48', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L47'] },
  { serialId: 'E48', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L48'] },
  { serialId: 'L49', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L48'] },
  { serialId: 'E49', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L49'] },
  { serialId: 'L50', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L49'] },
  { serialId: 'E50', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L50'] },
  { serialId: 'L51', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L50'] },
  { serialId: 'E51', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L51'] },
  { serialId: 'R2', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L51'] },
  { serialId: 'L52', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E52', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L52'] },
  { serialId: 'L53', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L52'] },
  { serialId: 'E53', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L53'] },
  { serialId: 'L54', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L53'] },
  { serialId: 'E54', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L54'] },
  { serialId: 'L55', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L54'] },
  { serialId: 'E55', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L55'] },
  { serialId: 'L56', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L55'] },
  { serialId: 'E56', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L56'] },
  { serialId: 'R3', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L56'] },
  { serialId: 'L57', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E57', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L57'] },
  { serialId: 'L58', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L57'] },
  { serialId: 'E58', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L58'] },
  { serialId: 'L59', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L58'] },
  { serialId: 'E59', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L59'] },
  { serialId: 'L60', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L59'] },
  { serialId: 'E60', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L60'] },
  { serialId: 'L61', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L60'] },
  { serialId: 'E61', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L61'] },
  { serialId: 'L62', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L61'] },
  { serialId: 'E62', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L62'] },
  { serialId: 'L63', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L62'] },
  { serialId: 'E63', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L63'] },
  { serialId: 'L64', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L63'] },
  { serialId: 'E64', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L64'] },
  { serialId: 'L65', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L64'] },
  { serialId: 'E65', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L65'] },
  { serialId: 'L66', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L65'] },
  { serialId: 'E66', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L66'] },
  { serialId: 'R4', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L66'] },
];

const c52 = [
  { serialId: 'L1', unlockAt: '2019-07-28T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E1', unlockAt: '2019-07-29T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'L2', unlockAt: '2019-07-30T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'E2', unlockAt: '2019-07-31T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'L3', unlockAt: '2019-08-04T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'E3', unlockAt: '2019-08-05T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'L4', unlockAt: '2019-08-06T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'E4', unlockAt: '2019-08-07T16:00:00.000Z', prerequisites: ['L4'] },
  { serialId: 'L5', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L4'] },
  { serialId: 'E5', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L5'] },
  { serialId: 'R1', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L5'] },
  { serialId: 'L6', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: [] },
  { serialId: 'E6', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L6'] },
  { serialId: 'L7', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L6'] },
  { serialId: 'E7', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L7'] },
  { serialId: 'L8', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L7'] },
  { serialId: 'E8', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L8'] },
  { serialId: 'L9', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L8'] },
  { serialId: 'E9', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L9'] },
  { serialId: 'L10', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L9'] },
  { serialId: 'E10', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L10'] },
  { serialId: 'L11', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L10'] },
  { serialId: 'E11', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L11'] },
  { serialId: 'L12', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L11'] },
  { serialId: 'E12', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L12'] },
  { serialId: 'L13', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L12'] },
  { serialId: 'E13', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L13'] },
  { serialId: 'L14', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L13'] },
  { serialId: 'E14', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L14'] },
  { serialId: 'L15', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L14'] },
  { serialId: 'E15', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L15'] },
  { serialId: 'R2', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L15'] },
  { serialId: 'L16', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: [] },
  { serialId: 'E16', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L16'] },
  { serialId: 'L17', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L16'] },
  { serialId: 'E17', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L17'] },
  { serialId: 'L18', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L17'] },
  { serialId: 'E18', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L18'] },
  { serialId: 'L19', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L18'] },
  { serialId: 'E19', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L19'] },
  { serialId: 'L20', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L19'] },
  { serialId: 'E20', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L20'] },
  { serialId: 'L21', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L20'] },
  { serialId: 'E21', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L21'] },
  { serialId: 'L22', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L21'] },
  { serialId: 'E22', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L22'] },
  { serialId: 'L23', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L22'] },
  { serialId: 'E23', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L23'] },
  { serialId: 'L24', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L23'] },
  { serialId: 'E24', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L24'] },
  { serialId: 'L25', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L24'] },
  { serialId: 'E25', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L25'] },
  { serialId: 'L26', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L25'] },
  { serialId: 'E26', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L26'] },
  { serialId: 'L27', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L26'] },
  { serialId: 'E27', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L27'] },
  { serialId: 'R3', unlockAt: '2019-09-17T06:27:18.948Z', prerequisites: ['L27'] },
];
const c52Plus = [
  ...c52,
  { serialId: 'L28', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E28', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L28'] },
  { serialId: 'L29', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L28'] },
  { serialId: 'E29', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L29'] },
  { serialId: 'L30', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L29'] },
  { serialId: 'E30', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L30'] },
  { serialId: 'L31', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L30'] },
  { serialId: 'E31', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L31'] },
  { serialId: 'L32', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L31'] },
  { serialId: 'E32', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L32'] },
  { serialId: 'L33', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L32'] },
  { serialId: 'E33', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L33'] },
  { serialId: 'L34', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L33'] },
  { serialId: 'E34', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L34'] },
  { serialId: 'L35', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L34'] },
  { serialId: 'E35', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L35'] },
  { serialId: 'L36', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L35'] },
  { serialId: 'E36', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L36'] },
  { serialId: 'L37', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L36'] },
  { serialId: 'E37', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L37'] },
  { serialId: 'L38', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L37'] },
  { serialId: 'E38', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L38'] },
  { serialId: 'L39', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L38'] },
  { serialId: 'E39', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L39'] },
  { serialId: 'L40', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L39'] },
  { serialId: 'E40', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L40'] },
  { serialId: 'L41', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L40'] },
  { serialId: 'E41', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L41'] },
  { serialId: 'L42', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L41'] },
  { serialId: 'E42', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L42'] },
  { serialId: 'L43', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L42'] },
  { serialId: 'E43', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L43'] },
  { serialId: 'L44', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L43'] },
  { serialId: 'E44', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L44'] },
  { serialId: 'L45', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L44'] },
  { serialId: 'E45', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L45'] },
  { serialId: 'L46', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L45'] },
  { serialId: 'E46', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L46'] },
  { serialId: 'L47', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L46'] },
  { serialId: 'E47', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L47'] },
  { serialId: 'R4', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L47'] },
  { serialId: 'L48', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E48', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L48'] },
  { serialId: 'L49', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L48'] },
  { serialId: 'E49', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L49'] },
  { serialId: 'L50', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L49'] },
  { serialId: 'E50', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L50'] },
  { serialId: 'L51', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L50'] },
  { serialId: 'E51', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L51'] },
  { serialId: 'L52', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L51'] },
  { serialId: 'E52', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L52'] },
  { serialId: 'L53', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L52'] },
  { serialId: 'E53', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L53'] },
  { serialId: 'R5', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L53'] },
  { serialId: 'L54', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E54', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L54'] },
  { serialId: 'L55', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L54'] },
  { serialId: 'E55', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L55'] },
  { serialId: 'L56', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L55'] },
  { serialId: 'E56', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L56'] },
  { serialId: 'L57', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L56'] },
  { serialId: 'E57', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L57'] },
  { serialId: 'L58', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L57'] },
  { serialId: 'E58', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L58'] },
  { serialId: 'R6', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L58'] },
  { serialId: 'L59', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E59', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L59'] },
  { serialId: 'L60', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L59'] },
  { serialId: 'E60', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L60'] },
  { serialId: 'L61', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L60'] },
  { serialId: 'E61', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L61'] },
  { serialId: 'L62', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L61'] },
  { serialId: 'E62', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L62'] },
  { serialId: 'L63', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L62'] },
  { serialId: 'E63', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L63'] },
  { serialId: 'L64', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L63'] },
  { serialId: 'E64', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L64'] },
  { serialId: 'L65', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L64'] },
  { serialId: 'E65', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L65'] },
  { serialId: 'L66', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L65'] },
  { serialId: 'E66', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L66'] },
  { serialId: 'L67', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L66'] },
  { serialId: 'E67', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L67'] },
  { serialId: 'L68', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L67'] },
  { serialId: 'E68', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L68'] },
  { serialId: 'R7', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: ['L68'] },
];
const c49 = [
  { serialId: 'L1', unlockAt: '2020-02-23T16:00:00.000Z', prerequisites: [] },
  { serialId: 'E1', unlockAt: '2020-02-24T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'L2', unlockAt: '2020-02-25T16:00:00.000Z', prerequisites: ['L1'] },
  { serialId: 'E2', unlockAt: '2020-02-26T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'L3', unlockAt: '2020-02-25T16:00:00.000Z', prerequisites: ['L2'] },
  { serialId: 'E3', unlockAt: '2020-02-26T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'L4', unlockAt: '2020-02-25T16:00:00.000Z', prerequisites: ['L3'] },
  { serialId: 'E4', unlockAt: '2020-02-26T16:00:00.000Z', prerequisites: ['L4'] },
  { serialId: 'L5', unlockAt: '2020-02-26T16:00:00.000Z', prerequisites: ['L4'] },
  { serialId: 'E5', unlockAt: '2020-02-26T16:00:00.000Z', prerequisites: ['L5'] },
  { serialId: 'L6', unlockAt: '2020-02-26T16:00:00.000Z', prerequisites: ['L5'] },
  { serialId: 'E6', unlockAt: '2020-02-26T16:00:00.000Z', prerequisites: ['L6'] },
];

const c349 = [
  { serialId: 'L349001', unlockAt: '2020-02-23T16:00:00.000Z ', displayId: 'L1', prerequisites: [] },
  { serialId: 'E349001', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E1', prerequisites: ['L349001'] },
  { serialId: 'L349002', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L2', prerequisites: ['L349001'] },
  { serialId: 'E349002', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E2', prerequisites: ['L349002'] },
  { serialId: 'L349003', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L3', prerequisites: ['L349002'] },
  { serialId: 'E349003', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E3', prerequisites: ['L349003'] },
  { serialId: 'L349004', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L4', prerequisites: ['L349003'] },
  { serialId: 'E349004', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E4', prerequisites: ['L349004'] },
  { serialId: 'L349005', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L5', prerequisites: ['L349004'] },
  { serialId: 'E349005', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E5', prerequisites: ['L349005'] },
  { serialId: 'L349006', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L6', prerequisites: ['L349005'] },
  { serialId: 'E349006', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E6', prerequisites: ['L349006'] },
  { serialId: 'L349007', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L7', prerequisites: ['L349006'] },
  { serialId: 'E349007', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E7', prerequisites: ['L349007'] },
  { serialId: 'L349008', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L8', prerequisites: ['L349007'] },
  { serialId: 'E349008', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E8', prerequisites: ['L349008'] },
  { serialId: 'L349009', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L9', prerequisites: ['L349008'] },
  { serialId: 'E349009', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E9', prerequisites: ['L349009'] },
  { serialId: 'L349010', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L10', prerequisites: ['L349009'] },
  { serialId: 'E349010', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E10', prerequisites: ['L349010'] },
  { serialId: 'L349011', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L11', prerequisites: ['L349010'] },
  { serialId: 'E349011', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E11', prerequisites: ['L349011'] },
  { serialId: 'L349012', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L12', prerequisites: ['L349011'] },
  { serialId: 'E349012', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E12', prerequisites: ['L349012'] },
  { serialId: 'L349013', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L13', prerequisites: ['L349012'] },
  { serialId: 'E349013', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E13', prerequisites: ['L349013'] },
  { serialId: 'L349014', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L14', prerequisites: ['L349013'] },
  { serialId: 'E349014', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E14', prerequisites: ['L349014'] },
  { serialId: 'L349015', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L15', prerequisites: ['L349014'] },
  { serialId: 'E349015', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E15', prerequisites: ['L349015'] },
  { serialId: 'L349016', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L16', prerequisites: ['L349015'] },
  { serialId: 'E349016', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E16', prerequisites: ['L349016'] },
  { serialId: 'L349017', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L17', prerequisites: ['L349016'] },
  { serialId: 'E349017', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E17', prerequisites: ['L349017'] },
  { serialId: 'L349018', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L18', prerequisites: ['L349017'] },
  { serialId: 'E349018', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E18', prerequisites: ['L349018'] },
  { serialId: 'L349019', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L19', prerequisites: ['L349018'] },
  { serialId: 'E349019', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E19', prerequisites: ['L349019'] },
  { serialId: 'L349020', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'L20', prerequisites: ['L349019'] },
  { serialId: 'E349020', unlockAt: '2020-02-23T16:00:00.000Z', displayId: 'E20', prerequisites: ['L349020'] },
  ...displayC3,
];

const C3_2 = c3.slice(0, 73);
const C31_2 = c31.slice(0, 105);
const C32_2 = c32.slice(0, 105);
const C33_2 = c33.slice(0, 105);
const C391_2 = c391.slice(0, 97);
const C392_2 = c392.slice(0, 97);
const C393_2 = c393.slice(0, 97);
const C349_2 = c349.slice(0, 113);

export const templatesList = [
  c991,
  c992,
  c993,
  c391,
  c392,
  c393,
  c200,
  c3,
  c216,
  c9x,
  c31,
  c32,
  c33,
  c4,
  c51,
  c52,
  c49,
  c349,
  c51Plus,
  c52Plus,
  c91Plus,
  c92Plus,
  c93Plus,
  C3_2,
  C31_2,
  C32_2,
  C33_2,
  C391_2,
  C392_2,
  C393_2,
  C349_2,
];

export const enum TemplateType {
  C991,
  C992,
  C993,
  C391,
  C392,
  C393,
  C200,
  C3,
  C216,
  C9X,
  C31,
  C32,
  C33,
  C4,
  C51,
  C52,
  C49,
  C349,
  C51PLUS,
  C52PLUS,
  C91PLUS,
  C92PLUS,
  C93PLUS,
  C3_2,
  C31_2,
  C32_2,
  C33_2,
  C391_2,
  C392_2,
  C393_2,
  C349_2,
}

export const selectTemplates = [
  {
    name: 'c991',
    value: TemplateType.C991,
  },
  {
    name: 'c992',
    value: TemplateType.C992,
  },
  {
    name: 'c993',
    value: TemplateType.C993,
  },
  {
    name: 'c391',
    value: TemplateType.C391,
  },
  {
    name: 'c392',
    value: TemplateType.C392,
  },
  {
    name: 'c393',
    value: TemplateType.C393,
  },
  {
    name: 'c200',
    value: TemplateType.C200,
  },
  {
    name: 'c3',
    value: TemplateType.C3,
  },
  {
    name: 'c216',
    value: TemplateType.C216,
  },
  {
    name: 'c9x',
    value: TemplateType.C9X,
  },
  {
    name: 'c31',
    value: TemplateType.C31,
  },
  {
    name: 'c32',
    value: TemplateType.C32,
  },
  {
    name: 'c33',
    value: TemplateType.C33,
  },
  {
    name: 'c4',
    value: TemplateType.C4,
  },
  {
    name: 'c51',
    value: TemplateType.C51,
  },
  {
    name: 'c52',
    value: TemplateType.C52,
  },
  {
    name: 'c49',
    value: TemplateType.C49,
  },
  {
    name: 'c349',
    value: TemplateType.C349,
  },
  {
    name: 'c51Plus',
    value: TemplateType.C51PLUS,
  },
  {
    name: 'c52Plus',
    value: TemplateType.C52PLUS,
  },
  {
    name: 'C91Plus',
    value: TemplateType.C91PLUS,
  },
  {
    name: 'C92Plus',
    value: TemplateType.C92PLUS,
  },
  {
    name: 'C93Plus',
    value: TemplateType.C93PLUS,
  },
  {
    name: 'C3_2',
    value: TemplateType.C3_2,
  },
  {
    name: 'C31_2',
    value: TemplateType.C31_2,
  },
  {
    name: 'C32_2',
    value: TemplateType.C32_2,
  },
  {
    name: 'C33_2',
    value: TemplateType.C33_2,
  },
  {
    name: 'C391_2',
    value: TemplateType.C391_2,
  },
  {
    name: 'C392_2',
    value: TemplateType.C392_2,
  },
  {
    name: 'C393_2',
    value: TemplateType.C393_2,
  },
  {
    name: 'C349_2',
    value: TemplateType.C349_2,
  },
];



// WEBPACK FOOTER //
// ./src/screens/stock/courseTemplate.ts